import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { IssueType } from '../../IssueTypesContext/types'
import { Permission } from '@cims-online/shared'
import { useIssueTypesContext } from '../../IssueTypesContext'
import CreateEditFormItems from '../../components/CreateEditFormItems'
import { CreateFormItemsValues } from '../../components/CreateEditFormItems/types'
import { useCreateIssueTypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { useProjectContext } from 'context/ProjectContext'

export function useCreate(): CreateHeaderActionOptions<IssueType> {
  const { loading, refetch } = useIssueTypesContext()
  const { projectId } = useProjectContext()
  const [create] = useCreateIssueTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createIssueType: {
        type: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    permission: Permission.CreateIssueType,
    entity: 'Type',
    loading,
    modal: {
      type: 'simple',
      body: <CreateEditFormItems />,
      onOk: async ({
        name,
        nonApplicableDispositionTypes,
        description,
      }: CreateFormItemsValues) => {
        await create({
          variables: {
            input: {
              name,
              projectId,
              description,
              nonApplicableIssueDispositionTypeIds:
                nonApplicableDispositionTypes?.map(({ value }) =>
                  value.toString()
                ),
            },
          },
        })
        refetch()
      },
    },
  }
}
